

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store/StoreConfig'
import VueQuickLoadmore from 'vue-quick-loadmore';
Vue.use(VueQuickLoadmore)

Vue.prototype.$http = axios
Vue.config.productionTip = false
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import "babel-polyfill";
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {App},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js